import {Action} from '@ngrx/store';

import {ITriggerBody, ITriggerStore} from '../../../dashboard/shared';
import {Device} from '../../../afb-api/models/device';

// HTTP Request Actions
export const RETRIEVE_TRIGGER = '[Trigger] Retrieve Trigger';
export const RETRIEVE_SUCCESS = '[Trigger] Retrieve Success';
export const RETRIEVE_FAIL = '[Trigger] Retrieve Fail';

export const SET_TRIGGER = '[Trigger] Set Trigger';
export const SET_TRIGGER_SUCCESS = '[Trigger] Set Trigger Success';
export const SET_TRIGGER_FAIL = '[Trigger] Set Trigger Fail';

export const CREATE_TRIGGER = '[Trigger] Create Trigger';
export const CREATE_SUCCESS = '[Trigger] Create Success';
export const CREATE_FAIL = '[Trigger] Create Fail';

export const UPDATE_TRIGGER = '[Trigger] Update Trigger';
export const UPDATE_SUCCESS = '[Trigger] Update Success';
export const UPDATE_FAIL = '[Trigger] Update Fail';

export const DELETE_TRIGGER = '[Trigger] Delete Trigger';
export const DELETE_SUCCESS = '[Trigger] Delete Success';
export const DELETE_FAIL = '[Trigger] Delete Fail';
// Loading Actions
// export const START_LOADING = '[Trigger] Start Loading';
export const START_RETRIEVING_TRIGGER = '[Trigger] Start Retrieving Trigger';
export const START_SETTING_TRIGGER = '[Trigger] Start Setting Trigger';
// Temporary Actions
export const UPDATE_ENTITIES = '[Trigger] Update Entities';


// Retrieve
export class RetrieveTriggerAction implements Action {
  readonly type = RETRIEVE_TRIGGER;

  constructor(public payload: {
    orgToken: string,
    deviceList: Device[]
  }) {
  }
}

export class RetrieveSuccessAction implements Action {
  readonly type = RETRIEVE_SUCCESS;

  constructor(public payload: {
    entities: { [deviceUuid: string]: ITriggerStore }
  }) {
  }
}

export class RetrieveFailAction implements Action {
  readonly type = RETRIEVE_FAIL;

  constructor() {
  }
}

// Set Trigger
export class SetTriggerAction implements Action {
  readonly type = SET_TRIGGER;

  constructor(public payload: {
    orgToken: string,
    selectedDeviceXTriggerList: Array<{ device: Device, trigger: ITriggerStore }>,
    newTriggerBody: ITriggerBody
  }) {
  }
}

export class SetTriggerSuccessAction implements Action {
  readonly type = SET_TRIGGER_SUCCESS;

  constructor(public payload: string) {
  }
}

export class SetTriggerFailAction implements Action {
  readonly type = SET_TRIGGER_FAIL;

  constructor() {
  }
}

/**
 * For Create & Update
 * TODO: Get trigger object from server after creation and pass those to CreateSuccess to update entities.
 *
 * Temporarily using UPDATE_ENTITIES for now
 */

// Create (should dispatch RetrieveTriggerAction if the request is successful)
// Cannot do it locally since there's no triggerId <- generated from the server
export class CreateTriggerAction implements Action {
  readonly type = CREATE_TRIGGER;

  constructor(public payload: {
    orgToken: string,
    deviceList: Device[],
    triggerBody: ITriggerBody
  }) {
  }
}

export class CreateSuccessAction implements Action {
  readonly type = CREATE_SUCCESS;

  constructor() {
  }
}

export class CreateFailAction implements Action {
  readonly type = CREATE_FAIL;

  constructor() {
  }
}

// Update
export class UpdateTriggerAction implements Action {
  readonly type = UPDATE_TRIGGER;

  constructor(public payload: {
    orgToken: string,
    deviceList: Device[],
    triggerBody: ITriggerBody
  }) {
  }
}

export class UpdateSuccessAction implements Action {
  readonly type = UPDATE_SUCCESS;

  constructor() {
  }
}

export class UpdateFailAction implements Action {
  readonly type = UPDATE_FAIL;

  constructor() {
  }
}

// Update Entities (is in reducer to update entities)
export class UpdateEntitiesAction implements Action {
  readonly type = UPDATE_ENTITIES;

  // Pass triggerIdList to delete triggers from the store
  constructor(public payload: {
    entities: { [deviceUuid: string]: ITriggerStore }
  }) {
  }
}

// Delete
export class DeleteTriggerAction implements Action {
  readonly type = DELETE_TRIGGER;

  constructor(public payload: {
    orgToken: string,
    triggerIdList: string[]
  }) {
  }
}

export class DeleteSuccessAction implements Action {
  readonly type = DELETE_SUCCESS;

  // Pass triggerIdList to delete triggers from the store
  constructor(public payload: string[]) {
  }
}

export class DeleteFailAction implements Action {
  readonly type = DELETE_FAIL;

  constructor() {
  }
}

// Loading
// export class StartLoadingAction implements Action {
//   readonly type = START_LOADING;

//   constructor() { }
// }
export class StartRetrievingTriggerAction implements Action {
  readonly type = START_RETRIEVING_TRIGGER;

  constructor() {
  }
}

export class StartSettingTriggerAction implements Action {
  readonly type = START_SETTING_TRIGGER;

  constructor() {
  }
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions
  // HTTP Requests
  = RetrieveTriggerAction
  | RetrieveSuccessAction
  | RetrieveFailAction
  | SetTriggerAction
  | SetTriggerSuccessAction
  | SetTriggerFailAction
  | CreateTriggerAction
  | CreateSuccessAction
  | CreateFailAction
  | UpdateTriggerAction
  | UpdateSuccessAction
  | UpdateFailAction
  | DeleteTriggerAction
  | DeleteSuccessAction
  | DeleteFailAction
  // Loading
  // | StartLoadingAction
  | StartRetrievingTriggerAction
  | StartSettingTriggerAction;
